// extracted by mini-css-extract-plugin
export default {"heading":"SeedInput_heading__v6F1u","input":"SeedInput_input__dp+FE"};